<template>
	<div class="cassie-vertical-md mt-1">
		<FilterBar
			hide-search-query-filter
			hide-brand-filter
			@clearFilters="domainFilter = null"
		>
			<template #after-filters>
				<Dropdown
					v-model="domainFilter"
					:items="resourceDomainItems"
					label="Domain"
					custom-sort
				/>
			</template>
		</FilterBar>
		<SectionCard>
			<template #title>
				Resources
			</template>
			<template #subtitle>
				All resources are grouped by domain, click to expand
			</template>
			<template #body>
				<v-expansion-panels>
					<v-expansion-panel
						v-for="(resourceDomain, index) in filteredResourceDomains"
						:key="index"
						@click="openResourcesDetails($event, resourceDomain.domain)"
					>
						<v-expansion-panel-header>
							<v-row>
								<v-col cols="10">
									<span class="font-weight-bold mr-2">
										{{ resourceDomain.domain }} :
									</span>
									{{ resourceDomain.count }}
								</v-col>
							</v-row>
						</v-expansion-panel-header>
						<v-expansion-panel-content v-if="resourcesByDomain[resourceDomain.domain]">
							<DataTable
								:headers="tableHeaders"
								:items="resourcesByDomain[resourceDomain.domain].resources"
								:options.sync="resourcesByDomain[resourceDomain.domain].options"
								:server-items-length="resourcesByDomain[resourceDomain.domain].totalResources"
								@update:options="updateOptions($event, resourceDomain.domain)"
							>
								<template #item.url="{ item }">
									{{ item.url }}
								</template>
							</DataTable>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</template>
		</SectionCard>
	</div>
</template>

<script>
import FilterBar from '../../../../../../../shared/components/filter-bar.vue'
import Dropdown from '../../../../../../../shared/components/dropdown.vue'
import SectionCard from '../../../../../../../shared/components/section-card.vue'
import DataTable from '../../../../../../../shared/components/data-table.vue'
import { getResourceOverview, getResourceLookup } from '../../../../../../../shared/utils/api/site-scanner.js'
export default {
	components: {
		FilterBar,
		Dropdown,
		SectionCard,
		DataTable
	},
	props: {
		scanGuid: String,
		userCanUseSiteScanner: Boolean
	},
	data () {
		return {
			resourceDomains: [],
			resourcesByDomain: {},
			openDomain: null,
			totalUrls: 0,
			domainFilter: null
		}
	},
	computed: {
		tableHeaders () {
			return [
				{ text: 'URL', value: 'url' }
			]
		},
		resourceDomainItems () {
			const domainItems = [
				{ value: null, text: 'View All' },
				...this.resourceDomains.map(({ domain }) => ({
					value: domain,
					text: domain
				})).sort((a, b) => a.text.localeCompare(b.text))
			]
			return domainItems
		},
		filteredResourceDomains () {
			return this.resourceDomains.filter(({ domain }) => {
				let check = true
				if (this.domainFilter) check = domain.toLowerCase() === this.domainFilter.toLowerCase()
				return check
			})
		}
	},
	async created () {
		await this.getResourceOverview()
	},
	methods: {
		async getResourceOverview () {
			const { data } = await getResourceOverview(this.scanGuid)
			this.resourceDomains = data.results
		},
		openResourcesDetails (event, domain) {
			const expansionOpen = event.currentTarget.classList.contains('v-expansion-panel-header--active')
			this.openDomain = domain
			if (!expansionOpen) {
				this.loadResourcesByDomain(domain)
			}
		},
		async loadResourcesByDomain (domain) {
			if (this.resourcesByDomain[domain]) return
			const { data } = await getResourceLookup(this.scanGuid, domain)
			const resourceData = {
				...data,
				resources: data.resources.map(resource => ({
					url: resource
				}))
			}
			this.$set(this.resourcesByDomain, domain, resourceData)
		},
		async updateOptions (options, domain) {
			const pageNumber = options.page
			const itemsPerPage = options.itemsPerPage === -1 ? this.resourcesByDomain[domain].totalResources : options.itemsPerPage
			const orderDirection = options.sortDesc[0] ? 'desc' : 'asc'
			const sortByIndex = this.tableHeaders.findIndex(header => header.value === options.sortBy[0])
			const sortBy = sortByIndex === -1 ? 0 : sortByIndex
			const { data } = await getResourceLookup(this.scanGuid, domain, itemsPerPage, pageNumber, sortBy, orderDirection)
			const resourceData = {
				...data,
				resources: data.resources.map(resource => ({
					url: resource
				})),
				options
			}
			this.$set(this.resourcesByDomain, domain, resourceData)
		}
	}
}
</script>
